import { render } from "./OverviewNote.vue?vue&type=template&id=09a50044&scoped=true"
import script from "./OverviewNote.vue?vue&type=script&lang=js"
export * from "./OverviewNote.vue?vue&type=script&lang=js"

import "./OverviewNote.vue?vue&type=style&index=0&id=09a50044&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a50044"]])

export default __exports__